module.exports = __webpack_public_path__ + "img/wasser-01.7c15b018.jpg";